// extracted by mini-css-extract-plugin
export var content = "_s4-1";
export var wrapper = "_s4-0";